require('../../../assets/scripts/common/directives/jv.PageRefresh.Directive.js');
require('../../../assets/scripts/common/video/jv.VideoPlayer.Directive.js');
require('../../../assets/scripts/common/video/jv.VideoPlayer.webpack.js');
require('../../../assets/scripts/videos/recruiter/jv.Cand.Details.Video.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.Svc.js');
require('../../../assets/scripts/videos/recruiter/jv.Cand.Details.SendVideoModal.js');
require('../../../assets/scripts/videos/recruiter/jv.Cand.Details.EvalReqMoreInfo.js');
require('../../../assets/scripts/videos/recruiter/jv.Cand.Details.evalSendReminder.js');
require('../../../assets/scripts/videos/recruiter/jv.Cand.Details.InviteReviewersModal.js');
require('../../../assets/scripts/videos/recruiter/jv.Cand.Details.sendReminder.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.App.webpack.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.App.Details.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.App.Evaluations.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.App.List.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.Details.Ctrl.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.Evaluations.Ctrl.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.Evaluations.Directive.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.Router.dummy.js');
